<template>
  <div class="home">
    <div class="topHeader" >
      <ul class="mainNav">
        <li v-for="(item,index) in navList"  :class="{'isActive':active==index}" :key="index" @click.stop="navhandleClick(index)">{{item}}</li>
        <el-button v-show="active === 0" size="mini" @click="() => visible=true">项目效果图维护</el-button>
      </ul>
    </div>
    <div v-if="active===0" class="containS">
      <project-survey :visible.sync="visible"></project-survey>
    </div>
    <div v-else class="contain">
      <project-team></project-team>
    </div>
  </div>
</template>

<script>

import projectSurvey from "./projectSurvey.vue"
import projectTeam from "./projectTeam.vue"

export default {
  components:{ projectSurvey ,projectTeam},
  data(){
    return{
      navList: ["项目概况", "项目团队"],
      active:0,
      visible: false,// 项目图片维护
    }
  },
  methods:{
  navhandleClick(index){
    this.active=index;
  },
  }
}
</script>


<style lang="scss" scoped src="./home.scss"/>

